// src/Layout/Sidebar/permissions.js

export const ROLE_PERMISSIONS = {
  SUPER_ADMIN: [
    "dashboard",
    "users",
    "departments",
    "roles",
    "rooms",
    "broadcasts",
    "whatsapp_mappings",
    "whatsapp_logs",
    "audit",
    "media",
    "reports",
    "security",
    "settings",
    "health",
    "support",
    "profile",
    "document_security",
  ],

  ADMIN: [
    "dashboard",
    "users",
    "departments",
    "roles",
    "rooms",
    "broadcasts",
    "whatsapp_mappings",
    "whatsapp_logs",
    "audit",
    "media",
    "reports",
    "security",
    "settings",
    "health",
    "support",
    "profile",
    "document_security",
  ],

  OPERATION_ADMIN: [
    "dashboard",
    "users",
    "departments",
    "rooms",
    "broadcasts",
    "whatsapp_mappings",
    "whatsapp_logs",
    "media",
    "reports",
    "health",
    "profile",
  ],

  GROUP_ADMIN: ["dashboard", "rooms", "profile"],

  SUPPORT_ADMIN: ["dashboard", "users", "health", "support", "profile"],

  VIEWER: ["dashboard", "reports", "profile"],

  AUDIT: ["dashboard", "audit", "media", "reports", "profile"],

  USER: ["profile"],
};
